module.exports = __webpack_public_path__ + "static/media/Valenciano-01.4d1811df.JPG";